import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

import WithPagination from 'components/WithPagination';
import DeviceItem from './DeviceItem';

const propTypes = {
  devices: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const DeviceList = ({ devices, match, onDelete }) => (
  <div className="DeviceList">
    <div className="DeviceList__header">
      <h3 className="section-title">Devices</h3>
      <Link to={`${match.url}/choose`} className="btn btn-primary">
        New
      </Link>
    </div>

    <Card className="minimal">
      <CardBody>
        <ul className="DeviceList__list">
          {
            devices.map(device =>
              <DeviceItem
                device={device}
                key={device.id}
                onDelete={onDelete}
              />
            )
          }
        </ul>
      </CardBody>
    </Card>
  </div>
);

DeviceList.propTypes = propTypes;

export default WithPagination(DeviceList);



// WEBPACK FOOTER //
// ./src/features/device/DeviceListContainer/DeviceList/DeviceList.js